export const shouldSkipCustomWarehouseBlur = (
    event: React.FocusEvent<HTMLInputElement>,
    contentElement: HTMLDivElement | null
) => {
    const nextFocusedElement = event.relatedTarget;

    return nextFocusedElement instanceof Node && contentElement?.contains(nextFocusedElement);
};
